import { ProductGate } from "./ProductGate";

/** AppGraph runs as its own product — the in-desktop window is the launch boundary. */
export function AppGraphApp() {
  return <ProductGate appId="appgraph" />;
}
